"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _SiteNavigation = require("components/SiteNavigation");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _temp, _class3, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _temp2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var SidebarMenuItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(SidebarMenuItem, _Component);

  function SidebarMenuItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, SidebarMenuItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(SidebarMenuItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "active", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "section", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "link", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "title", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "icons", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "children", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(SidebarMenuItem, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("li", {
        className: _classList.default.join('nav-item', this.section && 'nav-section', this.active && 'active')
      }, this.section ? _react.default.createElement("div", {
        className: "nav-section-title"
      }, this.title) : _react.default.createElement("a", {
        href: this.link
      }, this.title, this.icons && this.icons.length && _react.default.createElement("span", {
        className: "account-icon-list"
      }, this.icons.map(function (_ref, index) {
        var title = _ref.title,
            icon = _ref.icon;
        return _react.default.createElement("img", {
          key: index,
          className: "account-icon",
          src: icon,
          title: title
        });
      }))), this.section && _react.default.createElement("ul", null, this.children.map(function (child) {
        return _react.default.createElement(SidebarMenuItem, _extends({}, child, {
          key: child.id
        }));
      })));
    }
  }]);
  return SidebarMenuItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "active", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "section", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "icons", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
})), _class);
var SidebarNavigation = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(SidebarNavigation, _Component2);

  function SidebarNavigation() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, SidebarNavigation);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(SidebarNavigation)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "signUpText", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "signInText", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "userProfile", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "sidebarHeader", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "menuItems", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "hasCreateAccount", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(SidebarNavigation, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, _react.default.createElement("p", {
        className: "header"
      }, this.sidebarHeader), _react.default.createElement("div", {
        id: "mobile-nav-container"
      }, _react.default.createElement(_SiteNavigation.MobileSiteNavigation, {
        hasCreateAccount: this.hasCreateAccount,
        signUpText: this.signUpText,
        signInText: this.signInText,
        userProfile: this.userProfile
      })), _react.default.createElement("ul", null, this.menuItems.map(function (child) {
        return _react.default.createElement(SidebarMenuItem, _extends({}, child, {
          key: child.id
        }));
      })));
    }
  }]);
  return SidebarNavigation;
}(_react.Component), _temp2), (_descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "signUpText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "signInText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "userProfile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "sidebarHeader", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "menuItems", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "hasCreateAccount", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
})), _class3);
exports.default = SidebarNavigation;